// Delete
$('input[name="_method"][value="delete"]').parents('a').on('click', function(ev) {
    ev.preventDefault();
    if ($(this).data('confirm') && ! confirm($(this).data('confirm'))) {
        return;
    }
    var $form = $(this).find('form');
    $form.submit();
});

// Toggle tooltips
$('[data-toggle="tooltip"]').tooltip();
